import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Search from "../../assets/img/icons/search-normal.svg";
import useFetch from "../../hooks/useAxios";
import IconBox from "./IconBox";
const SearchInput = () => {
  const [searchResult, setsearchResult] = useState();
  const [searchvalue, setsearchvalue] = useState(null);
  const apiSearch = useFetch({
    method: "get",
    url: `api/residences/search`,
    noHeader: true,
    trigger: false,
    params: { q: searchvalue },
    argFunc: res => {
      setsearchResult(res.data);
    }
  });


  const Searchparams = e => {
    if (e.target.value.length >= 3) {
      setsearchvalue(e.target.value);
    }else
    if(e.target.value.length===0){
      setsearchvalue(null)
      setsearchResult()
    }
  };
  useEffect(
    () => {
      if (searchvalue !== null ) {
        apiSearch.reFetch();
      }
     
    },
    [searchvalue]
  );
  const navigate = useNavigate();

  return (
    <div className="SearchInput relative">
      <input
        className="SearchInput__input"
        placeholder="اقامتگاه مورد نظر خود را جست و جو کنید ..."
        onChange={e => Searchparams(e)}
      />
      <IconBox white small>
        {" "}<img className="" src={Search} />
      </IconBox>
      {searchResult &&
        <div className="dropbox-search">
          {searchResult.length > 0
            ? searchResult.map(i =>
             
                  <div
                    onClick={() => {
                      navigate(`/place/${i.code}/${i.slug}`);
                      setsearchResult();
                    }}
                    className="dropbox-search--div cursor-pointer"
                    key={i.code}
                  >
                    {i.title}
                  </div>
             
              )
            : <div>اقامتگاهی با این مشخصات یافت نشد</div>}
        </div>}
    </div>
  );
};

export default SearchInput;
